export default function snakeCase(value = '') {
    return value ? value.trim().toLowerCase().split(' ').join('_') : '';
}
